export default {
    message: {
        no_entries: 'Keine Benutzer gefunden.',
        search_user: 'Benutzer suchen',
        email: 'E-Mail',
        actions: 'Aktionen',
        internal_customer_id: 'Kundennummer',
        company: 'Einrichtung',
        monthly_budget: 'Budget (Monat)',
        remaining_budget: 'Restbudget (Monat)',
        user_roles: 'Benutzerrolle(n)',
        edit: 'Bearbeiten',
        impersonate: 'Als Benutzer anmelden',
        ROLE_USER: 'Benutzer',
        ROLE_ADMIN: 'Administrator',
        ROLE_SUPER_ADMIN: 'Super-Administrator',
        ROLE_SUPER_MANAGER: 'Super Manager',
        ROLE_MANAGER: 'Manager',
    }
}
